module.exports = __webpack_public_path__ + "static/img/uploadimg-tip.ad65175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uploadimg-tip.png
// module id = rjXw
// module chunks = 1